import { createSlice } from '@reduxjs/toolkit'

interface LoadingState {
  isOpen: boolean
  isOpenMasterData: boolean
}

const initialState: LoadingState = {
  isOpen: false,
  isOpenMasterData: false,
}

export const loadingSlice = createSlice({
  name: 'loading',
  initialState,
  reducers: {
    setOpenLoading: (state) => {
      state.isOpen = true
    },
    setCloseLoading: (state) => {
      state.isOpen = false
    },

    setOpenLoadingMasterData: (state) => {
      state.isOpenMasterData = true
    },
    setCloseLoadingMasterData: (state) => {
      state.isOpenMasterData = false
    },
  },
})

// Action creators are generated for each case reducer function
export const { setCloseLoading, setOpenLoading, setCloseLoadingMasterData, setOpenLoadingMasterData } =
  loadingSlice.actions

export default loadingSlice.reducer
